import React, { type ComponentProps, useEffect, useRef } from 'react';
import { type View } from 'react-native';

import { IconLink } from '../../../../../Icon';

// ─────────────────────────────────────────────────────────────────────────────

export const ActiveIngredientQuantityStepperButton = (props: Props) => {
  const { autoFocus, ...restProps } = props;

  // ─── Refs ────────────────────────────────────────────────────────────

  const ref = useRef<View>(null);

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    if (!autoFocus) return;

    try {
      ref.current?.focus();
    } catch {}
  }, [autoFocus]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <IconLink
      ref={ref}
      iconSize={30}
      width={40}
      height={40}
      palette="oatmeal-almost-transparent"
      accessibilityRole="button"
      {...restProps}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  autoFocus?: boolean;
} & ComponentProps<typeof IconLink>;
